import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=8d0d260a&scoped=true&"
import script from "./Metrics.vue?vue&type=script&lang=ts&"
export * from "./Metrics.vue?vue&type=script&lang=ts&"
import style0 from "./Metrics.vue?vue&type=style&index=0&id=8d0d260a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0d260a",
  null
  
)

export default component.exports